import { SportsStatIdConfig } from '@collector/desktop-feature-statistics'
import { BasketballStatId } from '@collector/sportsapi-client-legacy'

export function getTeamStatIdConfigs(
  isFourPointsShotEnabled: boolean,
): SportsStatIdConfig[] {
  return [
    { sportStatId: BasketballStatId.FieldGoalsScored },
    { sportStatId: BasketballStatId.FieldGoalsAttempts },
    ...(isFourPointsShotEnabled
      ? [
          { sportStatId: BasketballStatId.FourPointsScored },
          { sportStatId: BasketballStatId.FourPointsAttempts },
        ]
      : []),
    { sportStatId: BasketballStatId.ThreePointsScored },
    { sportStatId: BasketballStatId.ThreePointsAttempts },
    { sportStatId: BasketballStatId.TwoPointsScored },
    { sportStatId: BasketballStatId.TwoPointsAttempts },
    { sportStatId: BasketballStatId.FreeThrowsScored },
    { sportStatId: BasketballStatId.FreeThrowsAttempts },
    { sportStatId: BasketballStatId.ReboundsOffensive },
    { sportStatId: BasketballStatId.ReboundsDefensive },
    { sportStatId: BasketballStatId.ReboundsTotal },
    { sportStatId: BasketballStatId.Assists },
    { sportStatId: BasketballStatId.Steals },
    { sportStatId: BasketballStatId.Blocks },
    { sportStatId: BasketballStatId.Turnovers },
    { sportStatId: BasketballStatId.Fouls, name: 'Personal fouls' },
  ]
}

// TODO: allow to declare just BasketballStatId[] if other properties are not needed (format, edit)

export function getTeamStatsAccordionIdConfigs(
  isFourPointsShotEnabled: boolean,
): SportsStatIdConfig[] {
  const statIds = [
    BasketballStatId.FieldGoalsPercentage,
    BasketballStatId.TwoPointsPercentage,
    BasketballStatId.ThreePointsPercentage,
    ...(isFourPointsShotEnabled ? [BasketballStatId.FourPointsPercentage] : []),
    BasketballStatId.FreeThrowsPercentage,
  ]

  return statIds.map((sportStatId) => ({
    sportStatId,
    format: { percent: true },
    edit: { disabled: true },
  }))
}

export function getPlayerStatIdConfigs(
  isFourPointsShotEnabled: boolean,
): SportsStatIdConfig[] {
  return [
    { sportStatId: BasketballStatId.Points },
    ...(isFourPointsShotEnabled
      ? [{ sportStatId: BasketballStatId.FourPointsScored }]
      : []),
    { sportStatId: BasketballStatId.ThreePointsScored },
    { sportStatId: BasketballStatId.ReboundsTotal },
    { sportStatId: BasketballStatId.Assists },
    { sportStatId: BasketballStatId.Steals },
    { sportStatId: BasketballStatId.Blocks },
    { sportStatId: BasketballStatId.Turnovers },
    { sportStatId: BasketballStatId.Fouls },
    { sportStatId: BasketballStatId.Appearance },
    { sportStatId: BasketballStatId.MinutesInPlay },
    { sportStatId: BasketballStatId.StartingLineup },
    { sportStatId: BasketballStatId.PlusMinus },
    { sportStatId: BasketballStatId.FieldGoalsScored },
    { sportStatId: BasketballStatId.FieldGoalsAttempts },
    ...(isFourPointsShotEnabled
      ? [{ sportStatId: BasketballStatId.FourPointsAttempts }]
      : []),
    { sportStatId: BasketballStatId.ThreePointsAttempts },
    { sportStatId: BasketballStatId.TwoPointsScored },
    { sportStatId: BasketballStatId.TwoPointsAttempts },
    { sportStatId: BasketballStatId.FreeThrowsScored },
    { sportStatId: BasketballStatId.FreeThrowsAttempts },
    { sportStatId: BasketballStatId.ReboundsOffensive },
    { sportStatId: BasketballStatId.ReboundsDefensive },
    { sportStatId: BasketballStatId.WillNotPlay },
    { sportStatId: BasketballStatId.Substitute },
  ]
}
